import { render } from "./SinistroPagamentoDetalheView.vue?vue&type=template&id=652f1c58&scoped=true"
import script from "./SinistroPagamentoDetalheView.vue?vue&type=script&lang=js"
export * from "./SinistroPagamentoDetalheView.vue?vue&type=script&lang=js"

import "./SinistroPagamentoDetalheView.vue?vue&type=style&index=0&id=652f1c58&scoped=true&lang=css"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-652f1c58"]])

export default __exports__